import { defineSlotRecipe, defineStyles } from "@pandacss/dev";

export const slots = [
  "root",
  "view",
  "header",
  "title",
  "table",
  "body",
  "row",
  "weekday",
  "monthContainer",
  "month",
  "yearContainer",
  "year",
] as const;

const monthAndYearContainerStyles = defineStyles({
  width: "100%",
});

const monthAndYearStyles = defineStyles({
  borderRadius: "l",
  borderWidth: "m",
  borderColor: "border.neutral.bold",
  height: "-webkit-fill-available",
  color: "content.neutral.base.bold",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  _disabled: {
    cursor: "not-allowed",
    borderWidth: 0,
    color: "content.neutral.base.disable",
  },

  _notDisabled: {
    _hover: {
      background: "background.neutral.base.subtlest-hover",
      borderColor: "border.neutral.bold-hover",
      cursor: "pointer",
    },
  },
});

export const aromaDatepicker = defineSlotRecipe({
  className: "aroma-datepicker",
  jsx: [
    // withContainer is not taken into account on Input.DatePicker without a regex
    /DatePicker/,
    "Root",
    "Portal",
    "Header",
    "Views",
    "DayView",
    "MonthView",
    "YearView",
  ],
  slots,
  base: {
    root: {
      background: "background.neutral.base.subtlest",
    },
    view: {
      minWidth: "width.s",
      display: "flex",
      flexDirection: "column",
      gap: "gap.2",

      "&[data-view-month]": {
        height: "292px",
      },
      "&[data-view-year]": {
        height: "292px",
      },
    },
    header: {
      display: "flex",
      gap: "gap.2",
      justifyContent: "space-between",
    },
    table: {
      display: "flex",
      flexDirection: "column",
      gap: "gap.1",
      flexGrow: "1",
      "& [data-outside-range]": {
        cursor: "not-allowed",
      },
    },
    body: {
      display: "flex",
      flexDirection: "column",
      gap: "gap.1",
      flexGrow: "1",
    },
    title: {
      color: "content.neutral.base.subtle",
    },
    row: {
      display: "flex",
      justifyContent: "space-between",
      gap: "gap.1",
      height: "100%",
    },
    weekday: {
      width: "xl",
    },
    monthContainer: monthAndYearContainerStyles,
    yearContainer: monthAndYearContainerStyles,
    month: monthAndYearStyles,
    year: monthAndYearStyles,
  },
  variants: {
    withContainer: {
      true: {
        root: {
          borderRadius: "l",
          borderWidth: "m",
          borderColor: "border.neutral.subtle",
          padding: "padding.4",
          boxShadow: "effect.shadow.subtle-bottom",
        },
      },
    },
    fullWidth: {
      false: {
        root: {
          width: "fit-content",
        },
        view: {
          maxWidth: "fit-content",
        },
      },
    },
    hideDateOutsideRange: {
      true: {
        table: {
          "& [data-outside-range]": {
            pointerEvents: "none",
            "& > *": {
              display: "none",
            },
          },
        },
      },
    },
  },
  defaultVariants: {
    fullWidth: false,
  },
});
